module.exports = __webpack_public_path__ + "static/media/img_17.42238e23.png";